
export const ProviderType = {
    plethora: 'plethora',
    icode: 'icode',
};
